import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgActivityUpdated = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 16,
	viewBox: "0 0 21 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5.36719 2.70102C8.15667 -0.0331537 12.6863 -0.0331537 15.4758 2.70102C17.6269 4.80951 18.1254 7.92939 16.9536 10.5093",
			stroke: "currentColor",
			strokeWidth: 1.3,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.4752 12.5993C12.6857 15.3335 8.1561 15.3335 5.36661 12.5993C3.21547 10.4908 2.71704 7.37091 3.8888 4.79102",
			stroke: "currentColor",
			strokeWidth: 1.3,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.650391 6.18679L3.82472 4.77148L5.30258 7.81145",
			stroke: "currentColor",
			strokeWidth: 1.3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.0331 9.24465L16.9889 10.8505L15.3809 7.81055",
			stroke: "currentColor",
			strokeWidth: 1.3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgActivityUpdated;
